import React from 'react';

import { useQuery } from 'react-query';
import { DotBricksLoading, ListPagination, Search } from 'src/common/components';

import { fetchAccounts } from './api';
import { FilterButton, List, FilterResult, CreateAccountButton } from './components';
import { Action } from './constants';
import { AccountListContext } from './context';
import { useAccountsReducer } from './reducer';

const AccountList: React.FC = () => {
  const [state, dispatch] = useAccountsReducer();
  const { currentPage, search, filters, totalCount } = state;
  const { isLoading, isError } = useQuery(
    ['fetchAccounts', { currentPage, search, filters, basicInfo: true }],
    fetchAccounts,
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        dispatch({
          type: Action.SET_ACCOUNTS,
          accounts: data?.results || [],
          totalCount: data?.count || 0,
        });
      },
    }
  );

  // handles changing the page and api call with the changed paged
  const handleSetPage = (newPage: number): void => {
    dispatch({
      type: Action.SET_PAGE,
      page: newPage,
    });
  };

  const handleSetSearch = (searchValue: string): void => {
    // only set new page when search has changed
    const hasSearchChanged = searchValue.length !== search.length;
    const newPage = hasSearchChanged ? 1 : undefined;
    dispatch({
      type: Action.SET_SEARCH,
      search: searchValue,
      currentPage: newPage,
    });
  };

  if (isLoading) return <DotBricksLoading />;

  // TODO: IMPLEMENT LOADING COMPONENT
  if (isError) return <h2>ERROR :sad:</h2>;

  return (
    <AccountListContext.Provider value={{ state, dispatch }}>
      <div className="sm:px-6 lg:px-8 sm:pb-2 flex flex-col h-full pt-8 overflow-x-auto overflow-y-hidden">
        <h2 className="sm:px-0 px-4">Accounts</h2>
        <div className="sm:px-0 flex flex-shrink-0 px-4 mt-4">
          <Search setSearch={handleSetSearch} placeholder="Search by name, email or phone" />
          <FilterButton />
          <CreateAccountButton />
        </div>
        <FilterResult />
        <List />
        <ListPagination
          currentPage={currentPage}
          totalCount={totalCount}
          setCurrentPage={handleSetPage}
        />
      </div>
    </AccountListContext.Provider>
  );
};

export default AccountList;
